module.exports = __webpack_public_path__ + "static/img/pdf.57587f3e.png";